export enum RouteEnumV2 {
  'CalendarV2' = 'calendarV2',
  'CollectionV2' = 'collectionV2',
  'ConsultV2' = 'consultV2',
  'CourseRecordV2' = 'courseRecordV2',
  'LiveV2' = 'liveV2',
  'LiveRoomV2' = 'liveRoomV2',
  'LiveWhiteboardV2' = 'liveWhiteboardV2',
  'ScheduleV2' = 'scheduleV2',
  'ToeicV2' = 'toeicV2',
  'ToeicCertificateV2' = 'toeicCertificateV2',
  'ToeicExamV2' = 'toeicExamV2',
  'ToeicRecordV2' = 'toeicRecordV2'
}
